import { Marquee } from "./SitePrimitives";

type Audience = { name: string; description: string; image?: string };

function AudienceCard({ item, className = "" }: { item: Audience; className?: string }) {
  return (
    <article className={`flex gap-4 overflow-hidden rounded-xl bg-[rgba(11,15,15,0.43)] p-3 text-left min-[1200px]:h-[144px] ${className}`}>
      {item.image ? (
        <img src={item.image} alt="" className="h-[120px] w-[120px] shrink-0 object-contain" loading="lazy" />
      ) : null}
      <div className="flex w-[192px] flex-col gap-1 min-[810px]:w-auto">
        <h2 className="text-[14px] font-bold leading-[1.5] tracking-[-0.01em] text-[#F2F2F2] min-[810px]:text-[15px] min-[1200px]:text-[16px]">
          {item.name}
        </h2>
        <p className="site-body text-[#A3A3A3] min-[1200px]:text-[15px]">{item.description}</p>
      </div>
    </article>
  );
}

export function SiteAudiences({ items }: { items: Audience[] }) {
  if (!items.length) return null;
  return (
    <>
      <div className="hidden grid-cols-3 gap-4 px-[45px] min-[1200px]:grid">
        {items.map((item) => (
          <AudienceCard key={item.name} item={item} />
        ))}
      </div>
      <Marquee className="min-[1200px]:hidden" duration={30} align="start">
        {items.map((item) => (
          <div key={item.name} className="pr-4">
            <AudienceCard item={item} className="w-[360px] min-[810px]:w-[439px]" />
          </div>
        ))}
      </Marquee>
    </>
  );
}
